
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router} from "@angular/router";
import {Injectable} from "@angular/core";

import { UserService } from '../services/user.service';
import { TokenService } from '../services/token.service';

@Injectable()
export class AuthorizationGuard implements  CanActivate {

    private allowedRoles:string[];

    constructor(private userService: UserService, private tokenService: TokenService, private router: Router ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        this.allowedRoles = route.data["roles"];

        const allowed:boolean = this.userService.getRoles().filter(
            role=>this.allowedRoles.includes(role)).length > 0;
        
            if(allowed){
                return allowed;
            }else{
                return this.router.parseUrl('/accessdenied');
            }
        
    }
    
}
